var f = Object.defineProperty, i = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var a = (r, e, t) => e in r ? f(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, m = (r, e) => {
  for (var t in e || (e = {}))
    s.call(e, t) && a(r, t, e[t]);
  if (o)
    for (var t of o(e))
      n.call(e, t) && a(r, t, e[t]);
  return r;
}, p = (r, e) => i(r, c(e));
import d, { forwardRef as l } from "react";
import w from "../lib/IconBase.mjs";
import C from "../defs/CaretUp.mjs";
const R = l((r, e) => /* @__PURE__ */ d.createElement(w, p(m({ ref: e }, r), { weights: C })));
R.displayName = "CaretUp";
export {
  R as CaretUp
};
